module.exports = __webpack_public_path__ + "img/beneficiaries.123896de.svg";